import { useId } from "react";

export function FinloMark({ className = "h-9 w-9" }) {
  const gid = `finlo-g-${useId().replace(/:/g, "")}`;
  return (
    <svg viewBox="0 0 32 32" className={`${className} shrink-0 drop-shadow-[0_0_14px_rgba(0,200,150,0.35)]`} role="img" aria-label="Finlo">
      <defs>
        <linearGradient id={gid} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#00E5AC" />
          <stop offset="1" stopColor="#00B386" />
        </linearGradient>
      </defs>
      <rect width="32" height="32" rx="9" fill={`url(#${gid})`} />
      <path d="M10.5 24V12.5C10.5 10 12.5 8 15 8h7" fill="none" stroke="#04140D" strokeWidth="3.4" strokeLinecap="round" />
      <path d="M10.5 16.5h6" fill="none" stroke="#04140D" strokeWidth="3.4" strokeLinecap="round" />
      <path d="M18.5 23l5.5-5.5M20.5 17.5H24V21" fill="none" stroke="#04140D" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function FinloLogo({ size = "md", testid = "finlo-logo" }) {
  const text = size === "lg" ? "text-xl" : "text-lg";
  return (
    <span data-testid={testid} className="inline-flex items-center gap-2.5">
      <FinloMark />
      <span className={`font-display ${text} font-bold tracking-tight text-white leading-none`}>
        Finlo<span className="text-[#00C896]">.</span>
      </span>
    </span>
  );
}
